import React, { useState } from 'react'
import { IoMdClose } from "react-icons/io";
import productCategory from '../helpers/productCategory';
import { FaUpload } from "react-icons/fa";
import uploadImage from '../helpers/uploadImage';
import DisplayImage from './DisplayImage';
import { MdDelete } from "react-icons/md";
import SummaryApi from '../common';
import { toast } from 'react-toastify'


const AdminEditProduct = ({
    onClose,
    productData,
    fetchdata
}) => {
    const [data, setData] = useState({
        ...productData,
        productName: productData?.productName,
        brandName: productData?.brandName,
        category: productData?.category,
        productImage: productData?.productImage || [],
        description: productData?.description,
        price: productData?.price,
        sellingPrice: productData?.sellingPrice
    })
    const [openFullScreenImage, setOpenFullScreenImage] = useState(false)
    const [fullScreenImage, setFullScreenImage] = useState("")
    const handleOnchange = (e) => {
        const { name, value } = e.target

        setData((preve) => {
            return {
                ...preve,
                [name]: value
            }
        })

    }

    const handleUploadProduct = async (e) => {
        const file = e.target.files[0]
        const uploadImageCloudinary = await uploadImage(file)

        setData((preve) => {
            return {
                ...preve,
                productImage: [...preve.productImage, uploadImageCloudinary.url]
            }
        })

    }

    const handleDeleteProductImage = async (index) => {

        const newProductImage = [...data.productImage]
        newProductImage.splice(index, 1)
        setData((preve) => {
            return {
                ...preve,
                productImage: [...newProductImage]
            }
        })


    }


    const handleSubmit = async (e) => {
        e.preventDefault()
        const response = await fetch(SummaryApi.updateProduct.url, {
            method: SummaryApi.updateProduct.method,
            credentials: "include",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify(data)

        })
        const responseData = await response.json()
        if (responseData.success) {
            toast.success(responseData.message)
            onClose()
            fetchdata()

        }
        if (responseData.error) {
            toast.error(responseData?.message)
        }


    }
    return (
        <div className='fixed w-full h-full bg-slate-200 bg-opacity-35 top-0 left-0 right-0 bottom-0 flex justify-center items-center'>
            <div className='bg-white p-4 rounded w-full max-w-2xl h-full max-h-[80%] overflow-hidden'>
                <div className='flex justify-between items-center pb-3'>
                    <h2 className='font-bold text-lg'>Edit Products</h2>


                    <div className='w-fit ml-auto text-2xl hover:text-green-600 cursor-pointer' onClick={onClose}>
                        <IoMdClose />
                    </div>
                </div>
                <form className='grid p-4 gap-2 font-semibold overflow-y-scroll h-full pb-5' onSubmit={handleSubmit}>
                    <label htmlFor='productName'>Product Name :</label>
                    <input type='text' id='productName' name='productName' placeholder='Enter Product Name' value={data.productName} onChange={handleOnchange} className='p-2 bg-slate-100 border rounded' required />

                    <label htmlFor='brandName' className='mt-3'>Brand Name :</label>
                    <input type='text' id='brandName' name='brandName' placeholder='Enter Brand Name' value={data.brandName} onChange={handleOnchange} className='p-2 bg-slate-100 border rounded' required />

                    <label htmlFor='category' className='mt-3'>Category :</label>
                    <select value={data.category} name='category' onChange={handleOnchange} className='p-2 bg-slate-100 border rounded' required>
                        <option value={''}>Select</option>
                        {
                            productCategory.map((el, index) => {
                                return (
                                    <option value={el.value} key={el.value + index}>{el.label}</option>
                                )
                            })
                        }
                    </select>

                    <label htmlFor='productImage' className='mt-3'>Product Image :</label>
                    <label htmlFor='uploadImageInput'>
                        <div className='p-2 bg-slate-100 border rounded h-32 w-full flex justify-center items-center cursor-pointer'>

                            <div className='text-slate-500 flex justify-center items-center flex-col gap-2'>
                                <span className='text-4xl'> <FaUpload /></span>
                                <p className='text-sm'>Product Upload Image</p>
                                <input type='file' id='uploadImageInput' className='hidden' onChange={handleUploadProduct} />
                            </div>


                        </div>
                    </label>
                    <div>
                        <div className='flex items-center gap-2'>
                            {
                                data?.productImage[0] ? (
                                    data.productImage.map((el, index) => {
                                        return (
                                            <div className='relative group'>

                                                <img src={el} width={80} height={80} alt={el} className='bg-slate-100 border cursor-pointer' onClick={() => {
                                                    setOpenFullScreenImage(true)
                                                    setFullScreenImage(el)
                                                }} />
                                                <div className='absolute bottom-0 right-0 p-1 text-white bg-red-600 rounded-full hidden group-hover:block' onClick={() => handleDeleteProductImage(index)}>
                                                    <MdDelete />
                                                </div>
                                            </div>
                                        )
                                    })
                                ) : (
                                    <p className='text-red-500 text-xs'>*Please Upload Product Image</p>
                                )
                            }
                        </div>

                    </div>

                    <label htmlFor='price' className='mt-3'>Price :</label>
                    <input className='p-2 bg-slate-100 border rounded' id='price' name='price' required type='number' placeholder='Enter Price' value={data.price} onChange={handleOnchange} />


                    <label htmlFor='sellingPrice' className='mt-3'> Selling Price :</label>
                    <input className='p-2 bg-slate-100 border rounded' id='sellingPrice' required name='sellingPrice' type='number' placeholder='Enter Selling Price' value={data.sellingPrice} onChange={handleOnchange} />


                    <label htmlFor='description' className='mt-3'>Description :</label>
                    <textarea className='h-28 bg-slate-100 border resize-none p-1' placeholder='Enter Product Description' rows={4} onChange={handleOnchange} name='description' value={data.description}></textarea>


                    <button className='px-3 py-1 bg-blue-600 text-white mb-10 hover:bg-red-700'>Update Product</button>
                </form>

            </div >
            {
                openFullScreenImage && (
                    <DisplayImage onClose={() => setOpenFullScreenImage(false)} imgUrl={fullScreenImage} />
                )
            }



        </div >



    )
}

export default AdminEditProduct
